import { Typography } from "@mui/material"

const PageIntro = ({ children }) => {
    return <Typography variant='h4' color='primary' sx={{ textAlign: "center", padding: 4, fontWeight: 600 }}>{children}</Typography>
}

export default PageIntro